export enum ELocalStorage {
   USER_TOKEN = "kavalli_admin_token",
   USER_DATA = "kavalli_admin_user_data",
}
